import { render, staticRenderFns } from "./MenuSuperiorTrilhaPssc.vue?vue&type=template&id=3b1b8588&scoped=true&lang=pug"
import script from "./MenuSuperiorTrilhaPssc.vue?vue&type=script&lang=js"
export * from "./MenuSuperiorTrilhaPssc.vue?vue&type=script&lang=js"
import style0 from "./MenuSuperiorTrilhaPssc.vue?vue&type=style&index=0&id=3b1b8588&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b1b8588",
  null
  
)

export default component.exports